var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1194 0.878769C42.291 2.05046 42.291 3.95329 41.1194 5.12498L17.1231 29.1212C15.9514 30.2929 14.0486 30.2929 12.8769 29.1212L0.878769 17.1231C-0.292923 15.9514 -0.292923 14.0486 0.878769 12.8769C2.05046 11.7052 3.95329 11.7052 5.12498 12.8769L15.0047 22.7472L36.8825 0.878769C38.0542 -0.292923 39.957 -0.292923 41.1287 0.878769H41.1194Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.c04ca777a2677a88bb7e69a164bdb96a.svg";
export { ForwardRef as ReactComponent };